// extracted by mini-css-extract-plugin
module.exports = {"switcher":"LangSwitcher_switcher__rPDe9","btn":"LangSwitcher_btn__3a1l0","active":"LangSwitcher_active__PAcUF LangSwitcher_btn__3a1l0"};